// extracted by mini-css-extract-plugin
export default {"infractionList":"lostAndFound_list_infractionList__J6y-7","Mui-focused":"lostAndFound_list_Mui-focused__sA-c4","label":"lostAndFound_list_label__qQiqk"};